import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import Link from "next/link";
import { NavigationMenuLink } from "../ui/navigation-menu";
import { Icon } from "@/components/common/icon";
export function ListItem(t0) {
  const $ = _c(24);
  let children;
  let href;
  let icon;
  let props;
  let t1;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      children,
      href,
      icon,
      prefetch: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = href;
    $[3] = icon;
    $[4] = props;
    $[5] = t1;
    $[6] = title;
  } else {
    children = $[1];
    href = $[2];
    icon = $[3];
    props = $[4];
    t1 = $[5];
    title = $[6];
  }
  const prefetch = t1 === undefined ? true : t1;
  let t2;
  if ($[7] !== icon) {
    t2 = icon && <div className="grid size-10 shrink-0 place-content-center rounded-sm"><Icon name="user" size={40} /></div>;
    $[7] = icon;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== title) {
    t3 = <div className="leading-none font-medium">{title}</div>;
    $[9] = title;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== children) {
    t4 = <div className="text-muted-foreground line-clamp-2">{children}</div>;
    $[11] = children;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div className="flex flex-col gap-1 text-sm">{t3}{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== href || $[17] !== prefetch || $[18] !== t2 || $[19] !== t5) {
    t6 = <NavigationMenuLink closeOnClick={true} render={<Link href={href} prefetch={prefetch}>{t2}{t5}</Link>} />;
    $[16] = href;
    $[17] = prefetch;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== props || $[22] !== t6) {
    t7 = <li {...props}>{t6}</li>;
    $[21] = props;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}